export default defineNuxtRouteMiddleware(async (to, from) => {
  if(!to.path.endsWith('/')) return navigateTo({ path: `${ to.path }/`, query: to.query, hash: to.hash }, { replace: true, redirectCode: 301, external: true })
})